import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-info-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
})
export class InfoCardComponent {
  /** Título visible de la tarjeta */
  @Input() title = '';

  /** Icono en la esquina superior derecha (SVG inline o URL). */
  @Input() icon?: SafeHtml | string;

  /** Etiqueta accesible para el icono */
  @Input() iconAriaLabel = 'Icono decorativo';
}
